<script>
import userActivityReportsAPI from 'dashboard/api/userActivityReports';
import MetricCard from './components/overview/MetricCard.vue';
import FilterSelector from './components/FilterSelector.vue';
import UserActivityTable from './components/overview/UserActivityTable.vue';

export default {
  name: 'UserActivityReports',
  components: {
    MetricCard,
    FilterSelector,
    UserActivityTable,
  },
  data() {
    return {
      pageIndex: 0,
      analytics: {},
      userRankings: [],
      filters: {
        from: null,
        to: null,
        selectedAgents: [],
      },
      uiFlags: {
        isFetching: false,
      },
    };
  },
  mounted() {
    // FilterSelector will handle initial filter load
  },
  methods: {
    async loadReports() {
      this.uiFlags.isFetching = true;
      try {
        // Convert filter format for API
        const apiFilters = {
          since: this.filters.from
            ? new Date(this.filters.from * 1000).toISOString().split('T')[0]
            : null,
          until: this.filters.to
            ? new Date(this.filters.to * 1000).toISOString().split('T')[0]
            : null,
          user_id:
            this.filters.selectedAgents.length === 1
              ? this.filters.selectedAgents[0].id
              : '',
        };

        const [analyticsResponse, rankingsResponse] = await Promise.all([
          userActivityReportsAPI.getAnalytics(apiFilters),
          userActivityReportsAPI.getUserRankings(apiFilters),
        ]);

        this.analytics = analyticsResponse.data;
        this.userRankings = rankingsResponse.data.rankings;
      } catch (error) {
        // Handle error appropriately
      } finally {
        this.uiFlags.isFetching = false;
      }
    },
    onFilterChange(filters) {
      this.filters = filters;
      this.loadReports();
    },
    formatDuration(minutes) {
      if (minutes < 60) {
        return `${Math.round(minutes)}m`;
      }
      const hours = Math.floor(minutes / 60);
      const remainingMinutes = Math.round(minutes % 60);
      return `${hours}h ${remainingMinutes}m`;
    },
    formatDate(dateString) {
      return new Date(dateString).toLocaleDateString();
    },
    async onPageNumberChange(newPageIndex) {
      await this.loadReports();
      this.pageIndex = newPageIndex;
    },
  },
};
</script>

<template>
  <div class="flex-1 p-4 overflow-auto">
    <div class="flex flex-col gap-6">
      <!-- Header -->
      <!-- <div class="flex flex-col gap-2">
        <h1 class="text-2xl font-semibold text-slate-800 dark:text-slate-100">
          {{ $t('USER_ACTIVITY_REPORTS.HEADER') }}
        </h1>
        <p class="text-sm text-slate-600 dark:text-slate-400">
          {{ $t('USER_ACTIVITY_REPORTS.DESCRIPTION') }}
        </p>
      </div> -->

      <!-- Filters -->
      <!-- Filters -->
      <FilterSelector
        show-agents-filter
        :show-business-hours-switch="false"
        default-date-range="TODAY"
        @filter-change="onFilterChange"
      />

      <!-- Summary Cards -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        <MetricCard
          :header="$t('USER_ACTIVITY_REPORTS.METRICS.TOTAL_PAUSE_SESSIONS')"
          :is-loading="uiFlags.isFetching"
        >
          <div class="text-3xl font-bold text-slate-800 dark:text-slate-100">
            {{ analytics.pause_analytics?.total_pause_sessions || 0 }}
          </div>
        </MetricCard>

        <MetricCard
          :header="$t('USER_ACTIVITY_REPORTS.METRICS.TOTAL_PAUSE_DURATION')"
          :is-loading="uiFlags.isFetching"
        >
          <div class="text-3xl font-bold text-slate-800 dark:text-slate-100">
            {{
              formatDuration(
                analytics.pause_analytics?.total_pause_duration_minutes || 0
              )
            }}
          </div>
        </MetricCard>

        <MetricCard
          :header="$t('USER_ACTIVITY_REPORTS.METRICS.AVERAGE_PAUSE_DURATION')"
          :is-loading="uiFlags.isFetching"
        >
          <div class="text-3xl font-bold text-slate-800 dark:text-slate-100">
            {{
              formatDuration(
                analytics.pause_analytics?.average_pause_duration_minutes || 0
              )
            }}
          </div>
        </MetricCard>
      </div>

      <!-- User Activity Summary Table -->
      <MetricCard :header="$t('USER_ACTIVITY_REPORTS.AGENT_SUMMARY.HEADER')">
        <UserActivityTable
          :user-summary="analytics.user_summary || []"
          :is-loading="uiFlags.isFetching"
          :page-index="pageIndex"
          @page-change="onPageNumberChange"
        />
      </MetricCard>
    </div>
  </div>
</template>
